<script>
    // Слот инвентаря. Картинку предмета ищем по цепочке источников, сверху вниз:
    //   1) CDN маджестика — основной источник (одежда: clothesImages по хешу модели DLC,
    //      обычные предметы: img/inventory/items/<ItemId>.webp);
    //   2) прямая ссылка из itemsInfo.Icon, если она задана;
    //   3) старое «облако» document.cloud (зеркало cdn-ra3) — там лежит то, чего нет у маджестика;
    //   4) нарисованная иконка категории одежды / локальная картинка предмета;
    //   5) глиф иконо-шрифта inv-item.
    // Каждый промах (onerror) просто двигает нас на следующий источник.
    import { ItemType, itemsInfo, ItemId } from 'json/itemsInfo.js'
    import { buildSources, requestMajesticClothes, glyphClass } from './itemPhoto.js'

    export let item;
    export let defaultIcon;
    export let defaultName;
    export let defaultStyle;

    let iconInfo = itemsInfo [item.ItemId];

    let sources = [];
    let index = 0;
    let lastKey = "";

    $: if (item) {
        iconInfo = itemsInfo [item.ItemId];
        const key = item.ItemId + "|" + (item.Data || "");
        if (key !== lastKey) {
            lastKey = key;
            sources = buildSources(item, iconInfo);
            index = 0;
            // одежда: адрес у маджестика приходит асинхронно — ставим его первым
            requestMajesticClothes(item, (url) => {
                if (key !== lastKey || sources.indexOf(url) >= 0) return;
                sources = [url, ...sources];
                index = 0;
            });
        }
    }

    // промах: следующий источник, а когда они кончились — глиф иконо-шрифта
    const nextSource = () => {
        index = (index < sources.length - 1) ? index + 1 : sources.length;
    };

    $: currentSrc = sources[index] || "";
    $: showGlyph = !currentSrc;

    const getGlyphClass = glyphClass;

    const Bool = (text) => {
        return String(text).toLowerCase() === "true";
    }

    // предметы, которые рисуем мельче остальных
    const isSmallIcon = (itemId) => {
        const smallIcons = [
            ItemId.HealthKit,
            ItemId.CarKey,
        ];

        return smallIcons.includes(itemId);
    }

</script>
{#if item && item.ItemId != 0}
    <div class="item" class:active={item.active} class:anim={item.anim} class:noAnim={!item.anim} class:noUse={!item.use} on:mousedown on:mouseup on:mouseenter on:mouseleave>
        <div class="icon-wrapper">
            {#if showGlyph}
                <span class="glyph-fallback {getGlyphClass(iconInfo)}" />
            {:else}
                <img
                    src="{currentSrc}"
                    alt=""
                    class:small-icon={isSmallIcon(item.ItemId)}
                    on:error={nextSource}
                >
            {/if}
        </div>
        {#if defaultIcon === undefined && item.Count > 1 && item.ItemId !== 19 && iconInfo.functionType !== ItemType.Clothes && iconInfo.functionType !== ItemType.Weapons}<span>{item.Count}</span>{/if}
        {#if (item.ItemId === 19) && item.Data.split("_") && item.Data.split("_").length >= 1}<span>{item.Data.split("_")[0]}</span>{/if}
        {#if defaultIcon === undefined && iconInfo.functionType === 1 && item.ItemId != -5 && item.ItemId != -9 && item.ItemId != -1 && item.Data.split("_").length >= 2}<span>{Bool(item.Data.split("_")[2]) ? "М" : "Ж"}</span>{/if}
        {#if defaultIcon === undefined && item.ItemId == -9}<span>{item.Data.split("_")[0]}</span>{/if}
        {#if defaultIcon === undefined && item.ItemId == ItemId.SimCard}<span>{item.Data}</span>{/if}
        {#if defaultIcon === undefined && item.ItemId == 8020}<span>{(() => { try { return JSON.parse(item.Data || '{}').u || ''; } catch (e) { return ''; } })()}</span>{/if}
        {#if defaultIcon === undefined && item.ItemId == ItemId.VehicleNumber}<span>{item.Data}</span>{/if}
    </div>
{:else}
    <div class="item" class:active={item.active} class:anim={item.anim} class:noAnim={!item.anim} class:noUse={!item.use} on:mousedown on:mouseup on:mouseenter on:mouseleave>
    </div>
{/if}

<style>
    .icon-wrapper {
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .icon-wrapper img {
        max-width: 90%;
        max-height: 90%;
        object-fit: contain;
    }

    .icon-wrapper img.small-icon {
        max-width: 60%;
        max-height: 60%;
        transform: scale(0.8);
    }

    /* запасной глиф иконо-шрифта inv-item, когда картинки нет нигде */
    .glyph-fallback {
        font-family: 'inv-item' !important;
        font-size: 2.6vh;
        line-height: 1;
        color: #c9c9d4;
        display: flex;
        align-items: center;
        justify-content: center;
    }
</style>
